import {
  NavItemConfig,
  NavigationSection
} from './navigation.models';
import { RoutePath } from '../app/app.constants';

export enum NavItemCategory {
  PRIMARY = 'primary',
  SECONDARY = 'secondary'
}

export enum NavItem {
  MY_COURSE_PLAN = 'MY_COURSE_PLAN',
  ALL_COURSES_OVERVIEW = 'ALL_COURSES_OVERVIEW',
  COURSE_SETTINGS = 'COURSE_SETTINGS',
  HELP = 'HELP',
  PERFORMANCE_AND_GRADES = 'PERFORMANCE_AND_GRADES',
  RESOURCES_AND_EBOOKS = 'RESOURCES_AND_EBOOKS',
  TRAINING = 'TRAINING',
  STUDY = 'STUDY',
  TEST_PREP = 'TEST_PREP',
  STUDY_COURSE_PLAN = 'STUDY_COURSE_PLAN',
  STUDY_RESOURCES = 'STUDY_RESOURCES',
  PERFORMANCE = 'PERFORMANCE',
}

export const NavItemTextMap: Record<NavItem, string> = {
  [NavItem.MY_COURSE_PLAN]: 'My Course Plan',
  [NavItem.ALL_COURSES_OVERVIEW]: 'Assignments for All Courses',
  [NavItem.COURSE_SETTINGS]: 'Course Settings',
  [NavItem.HELP]: 'Help',
  [NavItem.PERFORMANCE_AND_GRADES]: 'Performance & Grades',
  [NavItem.RESOURCES_AND_EBOOKS]: 'Resources & eBooks',
  [NavItem.TRAINING]: 'Training',
  [NavItem.STUDY]: 'Study',
  [NavItem.TEST_PREP]: 'Test prep',
  [NavItem.STUDY_COURSE_PLAN]: 'Course plan',
  [NavItem.STUDY_RESOURCES]: 'Resources',
  [NavItem.PERFORMANCE]: 'Performance',
};

export const NavItemConfigMap: Record<NavItem, NavItemConfig> = {
  [NavItem.MY_COURSE_PLAN]: {
    category: NavItemCategory.PRIMARY,
    isInternal: true,
    disabled: false,
    navItem: NavItem.MY_COURSE_PLAN,
    path: RoutePath.COURSE,
    text: NavItemTextMap[NavItem.MY_COURSE_PLAN],
    showOnMobile: true,
    isTooltipItem: false,
    tooltipId: null,
  },
  [NavItem.ALL_COURSES_OVERVIEW]: {
    category: NavItemCategory.PRIMARY,
    isInternal: true,
    disabled: false,
    navItem: NavItem.ALL_COURSES_OVERVIEW,
    path: RoutePath.ASSIGNMENT_OVERVIEW,
    text: NavItemTextMap[NavItem.ALL_COURSES_OVERVIEW],
    showOnMobile: true,
    isTooltipItem: false,
    tooltipId: null
  },
  [NavItem.PERFORMANCE_AND_GRADES]: {
    category: NavItemCategory.PRIMARY,
    isInternal: false,
    disabled: false,
    navItem: NavItem.PERFORMANCE_AND_GRADES,
    path: null,
    text: NavItemTextMap[NavItem.PERFORMANCE_AND_GRADES],
    showOnMobile: true,
    isTooltipItem: false,
    tooltipId: null
  },
  [NavItem.RESOURCES_AND_EBOOKS]: {
    category: NavItemCategory.PRIMARY,
    isInternal: true,
    disabled: false,
    navItem: NavItem.RESOURCES_AND_EBOOKS,
    path: RoutePath.CATALOG,
    text: NavItemTextMap[NavItem.RESOURCES_AND_EBOOKS],
    showOnMobile: true,
    isTooltipItem: false,
    tooltipId: null
  },
  [NavItem.COURSE_SETTINGS]: {
    category: NavItemCategory.PRIMARY,
    disabled: false,
    isInternal: true,
    navItem: NavItem.COURSE_SETTINGS,
    path: RoutePath.SETTINGS,
    text: NavItemTextMap[NavItem.COURSE_SETTINGS],
    showOnMobile: true,
    isTooltipItem: false,
    tooltipId: null
  },
  [NavItem.HELP]: {
    category: NavItemCategory.PRIMARY,
    disabled: false,
    isInternal: true,
    navItem: NavItem.HELP,
    path: RoutePath.HELP,
    text: NavItemTextMap[NavItem.HELP],
    showOnMobile: true,
    isTooltipItem: false,
    tooltipId: null
  },
  [NavItem.TRAINING]: {
    category: NavItemCategory.PRIMARY,
    disabled: false,
    isInternal: true,
    navItem: NavItem.TRAINING,
    path: null,
    text: NavItemTextMap[NavItem.TRAINING],
    showOnMobile: false,
    isTooltipItem: true,
    tooltipId: 'header-nav-training-tooltip'
  },
  [NavItem.STUDY]: {
    category: NavItemCategory.PRIMARY,
    isInternal: true,
    disabled: false,
    navItem: NavItem.STUDY,
    path: RoutePath.STUDENT_STUDY,
    text: NavItemTextMap[NavItem.STUDY],
    showOnMobile: true,
    isTooltipItem: false,
    tooltipId: null
  },
  [NavItem.TEST_PREP]: {
    category: NavItemCategory.PRIMARY,
    isInternal: true,
    disabled: false,
    navItem: NavItem.TEST_PREP,
    path: RoutePath.TEST_PREP,
    text: NavItemTextMap[NavItem.TEST_PREP],
    showOnMobile: true,
    isTooltipItem: false,
    tooltipId: null
  },
  [NavItem.STUDY_COURSE_PLAN]: {
    category: NavItemCategory.PRIMARY,
    isInternal: true,
    disabled: false,
    navItem: NavItem.STUDY_COURSE_PLAN,
    path: RoutePath.COURSE,
    text: NavItemTextMap[NavItem.STUDY_COURSE_PLAN],
    showOnMobile: true,
    isTooltipItem: false,
    tooltipId: null
  },
  [NavItem.STUDY_RESOURCES]: {
    category: NavItemCategory.PRIMARY,
    isInternal: true,
    disabled: false,
    navItem: NavItem.STUDY_RESOURCES,
    path: RoutePath.CATALOG,
    text: NavItemTextMap[NavItem.STUDY_RESOURCES],
    showOnMobile: true,
    isTooltipItem: false,
    tooltipId: null
  },
  [NavItem.PERFORMANCE]: {
    category: NavItemCategory.PRIMARY,
    isInternal: true,
    disabled: false,
    navItem: NavItem.PERFORMANCE,
    path: RoutePath.STUDENT_PERFORMANCE,
    text: NavItemTextMap[NavItem.PERFORMANCE],
    showOnMobile: true,
    isTooltipItem: false,
    tooltipId: null
  },
};

export const instructorNavItems: NavigationSection[] = [
  {
    category: NavItemCategory.PRIMARY,
    items: [
      NavItemConfigMap.MY_COURSE_PLAN,
      NavItemConfigMap.RESOURCES_AND_EBOOKS,
      NavItemConfigMap.PERFORMANCE_AND_GRADES,
      NavItemConfigMap.COURSE_SETTINGS,
      NavItemConfigMap.TRAINING,
      NavItemConfigMap.HELP,
    ]
  }
];

export const studentNavItems: NavigationSection[] = [
  {
    category: NavItemCategory.PRIMARY,
    items: [
      NavItemConfigMap.MY_COURSE_PLAN,
      NavItemConfigMap.ALL_COURSES_OVERVIEW,
      NavItemConfigMap.RESOURCES_AND_EBOOKS,
      NavItemConfigMap.PERFORMANCE_AND_GRADES,
      NavItemConfigMap.TRAINING,
      NavItemConfigMap.HELP,
    ]
  }
];

export const studentStudyNavItems: NavigationSection[] = [
  {
    category: NavItemCategory.PRIMARY,
    items: [
      NavItemConfigMap.STUDY,
      NavItemConfigMap.TEST_PREP,
      NavItemConfigMap.STUDY_COURSE_PLAN,
      NavItemConfigMap.STUDY_RESOURCES,
      NavItemConfigMap.PERFORMANCE,
    ]
  }
];
